<template>
  <div class="org-placement-fields">
    <v-autocomplete
      :value="value.manager"
      :items="managerItems"
      item-text="text"
      item-value="value"
      label="¿A quién reporta?"
      :hint="required ? '' : 'Déjalo vacío para no ubicarla todavía'"
      :persistent-hint="!required"
      :rules="required ? [v => !!v || 'Elige a quién reporta'] : []"
      :clearable="!required"
      :disabled="disabled"
      outlined
      dense
      @input="update('manager', $event)"
    >
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle v-if="item.subtitle">{{ item.subtitle }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>

    <v-select
      :value="value.area || ''"
      :items="areaItems"
      label="Área"
      :disabled="disabled"
      outlined
      dense
      class="mt-2"
      @input="update('area', $event || null)"
    />
  </div>
</template>

<script>
import { HEAD_OPTION } from '../utils/org-chart.utils';

// Campos "¿A quién reporta?" + "Área", compartidos por Ubicar, Agregar persona
// y Confirmar candidato. v-model: { manager: personId | 'head' | null, area: string | null }
export default {
  name: 'OrgChartPlacementFields',
  props: {
    value: { type: Object, default: () => ({ manager: null, area: null }) },
    // Personas que pueden ser jefe (ya sin la persona ni quienes reportan a ella).
    people: { type: Array, default: () => [] },
    areas: { type: Object, default: () => ({}) },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    managerItems() {
      const people = [...this.people]
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        .map(person => ({ text: person.name, subtitle: person.title || '', value: person.personId }));
      return [{ text: 'Nadie (cabeza del organigrama)', subtitle: '', value: HEAD_OPTION }, ...people];
    },
    areaItems() {
      const areas = Object.keys(this.areas).map(key => ({ text: this.areas[key], value: key }));
      return [{ text: 'Sin área', value: '' }, ...areas];
    }
  },
  methods: {
    update(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue === undefined ? null : fieldValue });
    }
  }
};
</script>
